import { createAsyncThunk } from "@reduxjs/toolkit";
import WalletServices from "../../Services/WalletServices";

// Get wallet tier
export const fetchWalletTier = createAsyncThunk(
  "/fetchWalletTier",
  async ({ tierId }, { rejectWithValue }) => {
    try {
      const response = await WalletServices.getWalletTier({ tierId });
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response?.data || error.message);
    }
  }
);

// Get wallet account information
export const fetchWalletAccount = createAsyncThunk(
  "/fetchWalletAccount",
  async (_, { dispatch, rejectWithValue }) => {
    try {
      const response = await WalletServices.getWalletAccount();
      const tierId = response.data?.user?.tier_id;
      if (tierId) {
        dispatch(fetchWalletTier({ tierId }));
      }
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response?.data || error.message);
    }
  }
);

export const fetchWalletDesign = createAsyncThunk(
  "/getWalletDesign",
  async ({ tierId }, { rejectWithValue }) => {
    try {
      const response = await WalletServices.getWalletDesign({ tierId });
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response?.data || error.message);
    }
  }
);

// Get points history
export const fetchPointsHistory = createAsyncThunk(
  "bank/fetchPointsHistory",
  async (_, { rejectWithValue }) => {
    try {
      const response = await WalletServices.getPointsHistory();
      return response.data.content;
    } catch (error) {
      return rejectWithValue(error.response?.data || error.message);
    }
  }
);

// get google wallet qr code
export const fetchGoogleWalletQrCode = createAsyncThunk(
  "/fetchGoogleWalletQrCode",
  async (_, { rejectWithValue }) => {
    try {
      const response = await WalletServices.getGoogleWalletQrCode();
      const imageUrl = URL.createObjectURL(response.data);
      return imageUrl;
    } catch (error) {
      return rejectWithValue(error.response?.data || error.message);
    }
  }
);
// get apple wallet qr code
export const fetchAppleWalletQrCode = createAsyncThunk(
  "/fetchAppleWalletQrCode",
  async (_, { rejectWithValue }) => {
    try {
      const response = await WalletServices.getAppleWalletQrCode();
      const imageUrl = URL.createObjectURL(response.data);
      return imageUrl;
    } catch (error) {
      return rejectWithValue(error.response?.data || error.message);
    }
  }
);
